var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransPlusIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM10 6.00009C10.4418 6.00009 10.8 6.35826 10.8 6.80009V9.19999H13.2001C13.6419 9.19999 14.0001 9.55816 14.0001 9.99999C14.0001 10.4418 13.6419 10.8 13.2001 10.8H10.8V13.2001C10.8 13.6419 10.4418 14.0001 10 14.0001C9.55819 14.0001 9.20001 13.6419 9.20001 13.2001V10.8H6.80011C6.35828 10.8 6.00011 10.4418 6.00011 9.99999C6.00011 9.55816 6.35828 9.19999 6.80011 9.19999H9.20001V6.80009C9.20001 6.35826 9.55819 6.00009 10 6.00009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransPlusIco);
export default __webpack_public_path__ + "static/media/trans_plus_ico.8ccccd4b0871af95fd26cf9df0cebc7b.svg";
export { ForwardRef as ReactComponent };